import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { DayOfRaceDate } from '@cds/betting-offer/domain-specific/horse-racing';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { RouteTag } from '@frontend/sports/common/core/data-access/route';
import { UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';
import { RacingUrlParam, WinGameFixture } from '@frontend/sports/racing/feature/models';
import { Observable, map, of } from 'rxjs';

import { GreyhoundRacingApiService } from '../horse-racing-shared/services/greyhound-racing-api.service';

@Injectable({
    providedIn: 'root',
})
export class GreyhoundsRacingPagesGuard {
    nextraces: WinGameFixture[];

    constructor(
        private apiService: GreyhoundRacingApiService,
        private router: Router,
        private urlHelper: UrlHelperService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        if (route.data.tag === RouteTag.RacingRaces) {
            const url = this.urlHelper.getRaceUrl(SportConstant.Greyhounds, RacingUrlParam.Today);

            return this.apiService.getNextFixtures().pipe(
                map((f) => {
                    if (f.length <= 0) {
                        this.router.navigate([url]);

                        return false;
                    } else {
                        return true;
                    }
                }),
            );
        }
        if (route.data.tag === RouteTag.RacingToday) {
            const url = this.urlHelper.getRaceUrl(SportConstant.Greyhounds, RacingUrlParam.Tomorrow);

            return this.apiService.getDayOfRaceFixtures(DayOfRaceDate.Today).pipe(
                map((f) => {
                    if (!f?.fixtures?.length) {
                        this.router.navigate([url]);

                        return false;
                    } else {
                        return true;
                    }
                }),
            );
        }

        return of(true);
    }
}
